import { useEffect, useState } from "react";
import Header from "./components/Header";
import Main from "./components/Main";
import About from "./components/About";
import Trainers from "./components/Trainers";
import Pw from "./components/Powerlifting";
import Contact from "./components/Contact";
import "./styles.css";

function App({ segments }: any) {
  const {
    gymName,
    mainTitle,
    aboutUsTitle,
    aboutUsText,
    aboutImage,
    trainers,
    powerliftingDescription1,
    powerliftingDescription2,
    squatDescription1,
    squatDescription2,
    squatImage,
    benchDescription1,
    benchDescription2,
    benchImage,
    deadliftDescription1,
    deadliftDescription2,
    deadliftImage,
    address,
    phone,
  } = segments;

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const isMobileDevice =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator?.userAgent
      );
    const isDesktopSize = window?.innerWidth > 800;

    setIsDesktop(!isMobileDevice && isDesktopSize);
    window?.addEventListener("resize", () => {
      const isMobileDevice =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator?.userAgent
        );
      const isDesktopSize = window?.innerWidth > 800;

      setIsDesktop(!isMobileDevice && isDesktopSize);
    });
  }, []);

  return (
    <div className="App">
      <Header isDesktop={isDesktop}></Header>
      <Main
        isDesktop={isDesktop}
        gymName={gymName}
        mainTitle={mainTitle}
      ></Main>
      <About
        isDesktop={isDesktop}
        aboutUsTitle={aboutUsTitle}
        aboutUsText={aboutUsText}
        aboutImage={aboutImage}
      ></About>
      <Trainers isDesktop={isDesktop} trainers={trainers}></Trainers>
      <Pw
        isDesktop={isDesktop}
        powerliftingDescription1={powerliftingDescription1}
        powerliftingDescription2={powerliftingDescription2}
        squatDescription1={squatDescription1}
        squatDescription2={squatDescription2}
        squatImage={squatImage}
        benchDescription1={benchDescription1}
        benchDescription2={benchDescription2}
        benchImage={benchImage}
        deadliftDescription1={deadliftDescription1}
        deadliftDescription2={deadliftDescription2}
        deadliftImage={deadliftImage}
      ></Pw>
      <Contact address={address} phone={phone}></Contact>
    </div>
  );
}

export default App;
